module.exports = __webpack_public_path__ + "img/YourOnlineConsultations.bd2cd362.png";